// extracted by mini-css-extract-plugin
export default {"player":"player_player__I1gqK","play_btn":"player_play_btn__o3nbp","progress":"player_progress__PJnt1"};